import { HTMLExtUtils } from '@ssml-editor/core';
import { PARAGRAPH_HTML_NODE_NAME, PARAGRAPH_TYPE, PARAGRAPH_MARK } from './constant.js';

const paragraphElementToHtml = ({
  childrenHtml
}) => {
  return HTMLExtUtils.createElementAsString(
    PARAGRAPH_HTML_NODE_NAME,
    PARAGRAPH_TYPE,
    false,
    false,
    {
      mark: PARAGRAPH_MARK
    },
    childrenHtml
  );
};

export { paragraphElementToHtml };
//# sourceMappingURL=element-to-html.js.map
